import { render } from "./PageDataDiskon.vue?vue&type=template&id=8fff748a"
import script from "./PageDataDiskon.vue?vue&type=script&lang=js"
export * from "./PageDataDiskon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__